import { Component, OnInit, OnDestroy } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { CompanyCompanyService } from 'src/app/services/company-services/company-company-service/company-company.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { CompanyInfo } from 'src/app/models/company-data-model/company-info.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-company-dashboard',
  templateUrl: './company-dashboard.component.html',
  styleUrls: ['./company-dashboard.component.scss']
})
export class CompanyDashboardComponent implements OnInit, OnDestroy {

  companyInfo: CompanyInfo;
  getCompanyInfoSubscription: Subscription;
  refreshCompanyListenSubscription: Subscription;

  constructor(private companyService: CompanyCompanyService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getCompanyInfo();
    this.refreshCompanyListenSubscription = this.companyService.refreshCompanyListen().subscribe(
      (res) => {
        this.getCompanyInfo();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getCompanyInfo() {
    this.getCompanyInfoSubscription = this.companyService.getCompanyInfo().pipe(
      tap(o => this.companyInfo = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-university', 'company', '/account', [new BRoute('account-page.account', '/account'), new BRoute('company-page.company')]));
  }

  ngOnDestroy() {
    if (this.getCompanyInfoSubscription) { this.getCompanyInfoSubscription.unsubscribe(); }
    if (this.refreshCompanyListenSubscription) { this.refreshCompanyListenSubscription.unsubscribe(); }
  }
}
